$(document).ready(function(){

  const myModal = new HystModal();

  function exitIntentFired(){
      if(Cookies.get('exitIntent') != 'true'){
        myModal.open('#exitIntent')
      }
      Cookies.set('exitIntent', 'true', {expires: 30});
  }
  
  function detectExitIntent(event) {
    // Set the threshold for detecting exit intent (e.g., 50px from the top edge of the viewport)
    const exitIntentThreshold = 50;
  
    // Check if the user's mouse is moving towards the top edge of the viewport
    if (event.clientY <= exitIntentThreshold) {
      // Remove the event listener to prevent multiple firings
      document.removeEventListener("mousemove", detectExitIntent);
  
      // Fire the exitIntentFired function
      exitIntentFired();
    }
  }
  
  // Attach the event listener to the document
  document.addEventListener("mousemove", detectExitIntent);

  let lastScrollPosition = 0;
  let lastScrollTime = 0;
  const exitIntentThreshold = 3000; // Adjust this value to set the sensitivity
  
  function onExitIntentScroll() {
    const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    const currentTime = new Date().getTime();
    const timeDifference = currentTime - lastScrollTime;
    const scrollDifference = lastScrollPosition - currentScrollPosition;
  
    if (scrollDifference > 0 && (scrollDifference / timeDifference) * 1000 > exitIntentThreshold) {
      exitIntentFired();
    }
  
    lastScrollPosition = currentScrollPosition;
    lastScrollTime = currentTime;
  }
  
  if ('ontouchstart' in window || 'onmsgesturechange' in window) {
    window.addEventListener('scroll', onExitIntentScroll, false);
  }        

});      